angular.module('familyService', ['ui.router','constants'])
.factory('familyService', function($http, $q, $rootScope, myConfig) {

  var service = {};

	var _baseUrl = myConfig.apiUrl + 'rings/'; //'http://127.0.0.1:8000/v1/rings/vw_ring_families';

  // families
	service.fetchFamilies = function(additionalUrl){

      var deferred = $q.defer();
      var userToken = localStorage.getItem('userToken');
      if (additionalUrl){
        var url = _baseUrl + "vw_ring_families" + additionalUrl;
      } else {
        var userId = $rootScope.user.UID;
        var url = _baseUrl + "vw_ring_families?where=Closed is 0 and userid is " + userId
      }
      $http({
        method: 'GET',
        url: url,
  	    withCredenturlials: true,
        headers :{'authorization':'Basic ' + userToken}
         
	  	}).then(function(response){
        deferred.resolve(response.data);
      })
      return deferred.promise;
    }

  service.fetchFamiliesSimple = function(additionalUrl){

      var deferred = $q.defer();
      var userToken = localStorage.getItem('userToken');
      if (additionalUrl){
        var url = _baseUrl + "vw_ring_families_simple" + additionalUrl;
      }
      $http({
        method: 'GET',
        url: url,
        withCredenturlials: true,
        headers :{'authorization':'Basic ' + userToken}
         
      }).then(function(response){
        deferred.resolve(response.data);
      })
      return deferred.promise;
    }

  // families with items
   service.fetchFamilyView = function(additionalUrl){
    var tableName = 'vw_families';
    //var tableName = 'vw_observation?withCount=true';
    var deferred = $q.defer();
    // escape the user name
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + "vw_families" + additionalUrl;
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }


  /*
  * save location
  */
  service.updateFamily = function(dataToSend){
    var tableName = 'family';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    //var userId = $rootScope.user.UID;
    var url = _baseUrl + tableName;

    $http({
      method: 'PUT',
      url: url,
      data: dataToSend,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
         
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  return service;

});
